module.exports = __webpack_public_path__ + "0bfcd3be7f264401d4064aa665f688e5.jpg";